import { render, staticRenderFns } from "./FoodDetailView.vue?vue&type=template&id=08da4eb5"
import script from "./FoodDetailView.vue?vue&type=script&lang=js"
export * from "./FoodDetailView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports